import { hashEmail } from '@on3/ui-lib/utils/user';
import { type Checkout } from '@public/utils/tracking/types';

const trackGooglePurchase = async (
  userKey: string | number,
  userEmail: string,
  userIp: string,
  conversion: Checkout,
) => {
  window?.dataLayer?.push({
    event: 'purchase',
    emailAddress: await hashEmail(userEmail),
    client_ip_address: userIp,
    userKey,
    ...conversion,
  });
};

export { trackGooglePurchase };
